import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';

const CategoryPage = () => {
  const { categoryName, subcategory } = useParams();
  const [news, setNews] = useState([]);
  const [subcategories, setSubcategories] = useState([]); // সাব-মেনুর জন্য স্টেট
  const [visibleCount, setVisibleCount] = useState(50);
  const finalSubcategory = subcategory || 'all';
useEffect(() => {
    console.log("Category from URL:", categoryName);
    console.log("Subcategory from URL:", subcategory); // এখানে সাব-ক্যাটাগরি ভ্যারিয়েবলটি ঠিক আছে

    let q;
    if (subcategory) {
      q = query(
        collection(db, "news"),
        where("category", "==", categoryName),
        where("subcategory", "==", subcategory), 
        orderBy("timestamp", "desc")
      );
    } else {
      q = query(
        collection(db, "news"),
        where("category", "==", categoryName),
        orderBy("timestamp", "desc")
      );
    }

    const unsubscribeNews = onSnapshot(q, (snapshot) => {
      setNews(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const catQuery = query(collection(db, "categories"), where("name", "==", categoryName));
    const unsubscribeCat = onSnapshot(catQuery, (snapshot) => {
      if (!snapshot.empty) {
        const catData = snapshot.docs[0].data();
        setSubcategories(catData.subcategories || []);
      }
    });

    return () => {
      unsubscribeNews();
      unsubscribeCat();
    };
  // ডিপেন্ডেন্সি এরে-তে ভ্যারিয়েবলের নাম ছোট হাতের 'c' দিয়ে ঠিক করুন:
  }, [categoryName, subcategory]);

  return (
    <div style={{ maxWidth: '1400px', margin: 'auto', padding: '0 10px' }}>
      
      {/* ক্যাটাগরি এবং সাব-মেনু একসাথে এক রো-তে */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '20px', 
        padding: '12px 0', 
        borderBottom: '1px solid #ddd', 
        marginTop: '0px',
        flexWrap: 'wrap'
      }}>
        <h2 style={{ fontSize: '30px', fontWeight: 'bold', margin: '0', color: '#333', borderLeft: '5px solid #d2202a', paddingLeft: '15px', lineHeight: '1' }}>
          {categoryName}
        </h2>

       {/* সাব-মেনু বার (রেড আইকন ও হোভার ইফেক্টসহ) */}
<div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
  {subcategories.map((sub, index) => (
    <Link 
      key={index} 
      to={`/category/${categoryName}/${sub}`}
      style={{ 
        textDecoration: 'none', 
        color: '#333', 
        fontWeight: 500,
        fontSize: '17px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px', // আইকন এবং টেক্সটের মাঝখানে গ্যাপ
        transition: 'color 0.3s'
      }}
      // হোভার ইফেক্ট
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#d2202a'; // হোভারে টেক্সট লাল হবে
        e.currentTarget.querySelector('.red-circle').style.backgroundColor = '#d2202a'; // আইকন গাঢ় হবে
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = '#333';
        e.currentTarget.querySelector('.red-circle').style.backgroundColor = '#d2202a'; // আইকন আগের মতো লাল থাকবে
      }}
    >
      {/* রেড সার্কেল আইকন */}
      <span 
        className="red-circle"
        style={{ 
          width: '8px', 
          height: '8px', 
          borderRadius: '50%', 
          backgroundColor: '#d2202a', 
          display: 'inline-block' 
        }} 
      ></span>
      {sub}
    </Link>
  ))}
</div>
      </div>
    {/* ১. Featured Section (Balanced Layout) */}
<div style={{ 
  display: 'grid', 
  gridTemplateColumns: '1.0fr 1fr', // বামের বড় ছবির প্রস্থ কমিয়ে ১.২ করলাম
  gap: '5px', 
  marginBottom: '40px',
  width: '100%' 
}}>
  
  {/* বামের বড় নিউজ */}
<Link 
  to={`/${news[0]?.categorySlug || 'general'}/${news[0]?.subcategorySlug || 'general'}/${news[0]?.id}`}
  style={{ 
    position: 'relative', 
    display: 'block', 
    textDecoration: 'none',
    transition: 'filter 0.2s ease'
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.filter = 'brightness(.95)'; // হালকা আলোর ঝলকানি
    e.currentTarget.querySelector('h2').style.color = '#FFDF00'; // গোল্ডেন কালার
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.filter = 'brightness(1)'; // আগের অবস্থায় ফেরা
    e.currentTarget.querySelector('h2').style.color = '#fff'; // সাদা কালার
  }}
>
  <img src={news[0]?.image} style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
  <h2 style={{ 
    position: 'absolute', 
    bottom: 0, 
    left: 0, 
    width: '100%', 
    height: '100%', // পুরো ইমেজ জুড়ে জায়গা নেওয়ার জন্য
    color: '#fff', 
    padding: '30px', // প্যাডিং কমিয়ে দিলাম
    margin: 0, 
    fontSize: '28px',
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    display: 'flex',          // ফ্লেক্স ব্যবহার করলাম
    justifyContent: 'center', // ডানে-বামে মাঝখানে
    alignItems: 'flex-end',   // নিচে রাখার জন্য (একদম মাঝখানে চাইলে 'center' দিন)
    textAlign: 'center',      // টেক্সট সেন্টারে রাখার জন্য
    transition: 'color 0.1s ease' 
}}>
    {news[0]?.title}
</h2>
</Link>
  
{/* ডানের ৪টি নিউজ */}
<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
  {news.slice(1, 5).map(item => (
    <Link 
      key={item.id} 
    to={`/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`}
      style={{ 
        position: 'relative', 
        display: 'block', 
        textDecoration: 'none',
        overflow: 'hidden' // ছবির বাইরের অংশ যেন না দেখায়
      }}
      // মাউস নিলে লেখা বা ইফেক্ট পরিবর্তনের লজিক
     onMouseEnter={(e) => {
    // টেক্সট কালার পরিবর্তন
    const textElement = e.currentTarget.querySelector('p');
    if (textElement) {
        textElement.style.color = '#FFDF00'; // গোল্ডেন কালার
        // হোভার করলে ব্যাকগ্রাউন্ড আরও গাঢ় করে দিলাম (0.9)
        textElement.style.background = 'linear-gradient(transparent, rgba(0,0,0,0.9))';
    }
    e.currentTarget.style.filter = 'brightness(1.1)';
}}

onMouseLeave={(e) => {
    const textElement = e.currentTarget.querySelector('p');
    if (textElement) {
        textElement.style.color = '#fff';
        // মাউস সরালে আগের অপাসিটিতে ফিরে যাবে (0.7)
        textElement.style.background = 'linear-gradient(transparent, rgba(0,0,0,0.7))';
    }
    e.currentTarget.style.filter = 'brightness(1)';
}}
    >
      <img src={item.image} style={{ width: '100%', height: '170px', objectFit: 'cover', transition: '0.2s' }} />
      
      <p style={{ 
    position: 'absolute', 
    bottom: 0, 
    width: '100%', 
    fontSize: '18px',
    lineHeight: '1.2',    // এই লাইনটি যোগ করুন, মান কমিয়ে ১.০ পর্যন্ত করতে পারেন
    textAlign: 'center',
    fontWeight: 'bold', // আপনি যেহেতু 'normal' চেয়েছিলেন
    color: '#fff', 
    padding: '15px 10px', // প্যাডিংটা একটু বাড়িয়ে দিলাম যাতে ব্যাকগ্রাউন্ড সুন্দরভাবে দেখা যায়
    margin: 0, 
    // ব্যাকগ্রাউন্ডের অপাসিটি শুরুতে কম রাখলাম (0.7)
    background: 'linear-gradient(transparent, rgba(0,0,0,0.7))', 
    boxSizing: 'border-box',
    transition: 'all 0.3s ease' // ট্রানজিশন সবকিছুর ওপর দিলাম
}}>
    {item.title}
</p>
    </Link>
  ))}
</div>
</div>

   
{/* ২. বাকি নিউজ লিস্ট (Left Image, Right Content) */}
<div style={{ 
  maxWidth: '1100px', 
  margin: '40px auto', 
  padding: '0 10px' 
}}>
  <div style={{ 
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr', // ২ কলাম লেআউট
    gap: '10px' 
  }}>
    {news.slice(5, 5 + visibleCount).map(item => (
      <Link 
        key={item.id} 
      to={`/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`}
        style={{ 
          display: 'flex', // ইমেজ ও টেক্সট পাশাপাশি রাখার জন্য
          gap: '15px', 
          textDecoration: 'none', 
          color: '#333333', 
          borderBottom: '1px solid #eee', 
          paddingBottom: '15px',
          transition: '0.4s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.filter = 'brightness(.95)'; 
          const title = e.currentTarget.querySelector('h3');
          if(title) title.style.color = '#4169e1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.filter = 'brightness(1)';
          const title = e.currentTarget.querySelector('h3');
          if(title) title.style.color = '#333333';
        }}
      >
        {/* বামে ছবি */}
        <img 
          src={item.image} 
          style={{ width: '150px', height: '90px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} 
        />
        
        {/* ডানে হেডলাইন ও ডিটেইলস */}
        <div>
          <h3 style={{ margin: '0 0 10px 0', fontSize: '21px', fontWeight: 'bold', color: '#333333', lineHeight: '1.2', transition: '0.1s' }}>
            {item.title}
          </h3>
          <p style={{ fontSize: '17px', color: '#333333', lineHeight: '1.3', margin: 0, textAlign: 'justify' }}>
            {item.content?.length > 100 ? `${item.content.substring(0, 130)}...` : item.content}
          </p>
        </div>
      </Link>
    ))}
  </div>

  {/* আরও পড়ুন বাটন */}
  {news.length > 5 + visibleCount && (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      <button 
        onClick={() => setVisibleCount(visibleCount + 50)}
        style={{ 
          padding: '10px 25px', 
          fontSize: '16px', 
          cursor: 'pointer', 
          background: '#4169e1', 
          color: '#fff', 
          border: 'none', 
          borderRadius: '4px' 
        }}
      >
        আরও পড়ুন
      </button>
    </div>
  )}
</div>

    </div>
  );
};

export default CategoryPage;